import React from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { WintSuperkollAPIModelAgingIncomingInvoices } from "wint-api-client/dist/types";
//#endregion
import useOnViewInfo from "../useIncomingInvoiceViewInfo";
import useIncomingInvoiceFileViewer from "../useFileViwer";
import useAgingIncomingInvoiceSnoozeAction from "../actions/useAgingIncomingInvoiceSnoozeAction";

function useAgingIncomingInvoiceTodoFormHelpers(
  agingInvoice: WintSuperkollAPIModelAgingIncomingInvoices.AgingIncomingInvoiceTodoItem,
  onActionSuccess?: () => void
) {
  const formRef = React.useRef<FormHandles>(null);

  const onViewInfoClick = useOnViewInfo(agingInvoice.incomingInvoiceId, formRef);

  const submitInvoiceForm = (submitFunc?: (values: any) => Promise<any>) => {
    return (formRef.current && formRef.current.submit(submitFunc)) || new Promise<void>((resolve) => resolve());
  };

  const fileViewerComponent = useIncomingInvoiceFileViewer(agingInvoice?.incomingInvoiceId, agingInvoice?.attachments);
  const snoozeAction = useAgingIncomingInvoiceSnoozeAction(agingInvoice.incomingInvoiceId, onActionSuccess);

  return {
    formRef,
    fileViewerComponent,
    snoozeAction,
    onViewInfoClick,
    submitInvoiceForm,
  };
}

export default useAgingIncomingInvoiceTodoFormHelpers;
